module.exports = function (name, context, options) {
  if (options === undefined) {
    options = context;
    context = {};
  }

  $.extend(context, options.hash);
  return Gryphon.templates[name](context);
};
